import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const Body = styled.div`
  flex: 1;
  margin-bottom: ${({ theme }) => theme.spacings.abs32}px;
`;

export const CancelLink = styled(Link)<{
  disabled: boolean;
}>`
  color: ${({ disabled, theme }) =>
    disabled ? theme.colors.grey(1) : theme.colors.ctaBlue(-1)};
  ${({ disabled }) => (disabled ? 'cursor: not-allowed;' : '')}
  ${({ disabled }) => (disabled ? 'pointer-events: none;' : '')}
  font-weight: 500;
  margin-top: ${({ theme }) => theme.spacings.abs8}px;
`;

export const Footer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  padding: 0 ${({ theme }) => theme.spacings.abs8}px
    ${({ theme }) => theme.spacings.abs8}px;
`;

export const TextContainer = styled.div`
  padding: 0 ${({ theme }) => theme.spacings.abs8}px;
`;

export const TitleContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spacings.abs16}px;
`;
